import { z } from "zod";

/**
 * schemas
 */

export const vrsSchema = z.object({
  v: z.number(),
  r: z.string(),
  s: z.string(),
});

export const eip2098SignatureSchema = z.object({
  yParity: z.number(),
  r: z.string(),
  s: z.string(),
});

/**
 * types
 */

export type VRS = z.infer<typeof vrsSchema>;
export type EIP2098Signature = z.infer<typeof eip2098SignatureSchema>;
